import React from 'react'

export interface ITextCell {
  content: any
}

export const TextCell: React.FC<ITextCell> = props => {
  if (typeof props.content === 'object') return <>{JSON.stringify(props.content)}</>

  return props.content
}

export default React.memo(TextCell)
